import { all } from 'redux-saga/effects';

import fetchMaintenances from './fetchMaintenances';

export default function* () {
    yield all([fetchMaintenances()]);
}
